module.exports = __webpack_public_path__ + "img/myrenwu.1f7688cf.png";